export default class MobileMenu {
    constructor() {
        const hamburger = document.getElementById('hamburger');
    
        if (!hamburger) {
            return;
        }
    
        const menu = document.getElementById('menu-primary-menu'),
            overlay = document.getElementById('menu-overlay');
    
        const close = () => {
            menu?.classList.remove('is-active');
            hamburger.classList.remove('is-active');
            overlay?.classList.remove('is-active');
            document.documentElement.classList.remove('has-menu-open');
        };
    
        hamburger.addEventListener('click', () => {
            menu?.classList.toggle('is-active');
            hamburger.classList.toggle('is-active');
            overlay?.classList.toggle('is-active');
            document.documentElement.classList.toggle('has-menu-open');
        });

        document.querySelectorAll('.mega-indicator').forEach(function (indicator) {
            indicator.addEventListener('click', function (e) {
              e.preventDefault();
              e.stopPropagation();
        
              const parentItem = this.closest('.mega-menu-item');
              const submenu = parentItem.querySelector('.mega-menu-row .mega-sub-menu');
            //   const subsubmenu = parentItem.querySelector('.mega-sub-menu .mega-sub-menu');

              if (submenu) {
                const isOpen = submenu.style.display === 'block';
        
                // Optionally close other open submenus here if needed
                // document.querySelectorAll('.mega-sub-menu').forEach(sm => sm.style.display = 'none');
        
                submenu.style.display = isOpen ? 'none' : 'block';
                // subsubmenu.style.display = isOpen ? 'none' : 'block';
                this.setAttribute('aria-expanded', !isOpen);
              }
            });
          });
    }
}
